import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { nanoid } from 'nanoid';
import { triggerClickAddToCalendarAnalytics } from '~/analytics/analytics.listener';

import styles from './AddToCalendarButton.scss';
import { bookingsSelectors } from '~/api';
import { icsSelectors } from './ics.selectors';
import { dateUtils } from '~/routes/utils';

const REMINDER_TIME = 120;

export class AddToCalendarButton extends PureComponent {
  onClick = (event) => {
    triggerClickAddToCalendarAnalytics();
    if (window.navigator.msSaveBlob !== undefined) {
      event.preventDefault();
      window.navigator.msSaveBlob(this.getBlob(), 'event.ics');
      return false;
    }
  };

  getBlob() {
    return new Blob([this.createCalendarEvent()], {
      type: 'text/calendar;charset=utf-8',
    });
  }

  createCalendarEvent() {
    const {
      eventLocation,
      eventTitle,
      eventStartDate,
      eventEndDate,
      eventGeolocation,
      eventDescription,
    } = this.props;
    return [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'BEGIN:VEVENT',
      `DTSTAMP:${dateUtils.getIcsDateTime(new Date())}`,
      'STATUS:CONFIRMED',
      `UID:${nanoid()}@johnlewis`,
      'SEQUENCE:0',
      `SUMMARY:${eventTitle}`,
      `DTSTART:${eventStartDate}`,
      `DTEND:${eventEndDate}`,
      `DESCRIPTION:${eventDescription}`,
      `LOCATION:${eventLocation}`,
      `GEO:${eventGeolocation}`,
      'BEGIN:VALARM',
      `TRIGGER:-PT${REMINDER_TIME}M`,
      'ACTION:DISPLAY',
      'END:VALARM',
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\n');
  }

  render() {
    return (
      <div className={styles.buttonHolder}>
        <a
          download="event.ics"
          href={`data:text/calendar;charset=utf-8,${encodeURIComponent(
            this.createCalendarEvent(),
          )}`}
          onClick={this.onClick}
        >
          Add to calendar
        </a>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  const appointmentTypeId = bookingsSelectors.selectAppointmentTypeId(state);
  return {
    eventLocation: icsSelectors.selectIcsEventLocation(appointmentTypeId)(state),
    eventTitle: icsSelectors.selectIcsEventTitle(appointmentTypeId)(state),
    eventStartDate: icsSelectors.selectIcsEventStartDate(state),
    eventEndDate: icsSelectors.selectIcsEventEndDate(state),
    eventGeolocation: icsSelectors.selectIcsEventGeolocation(state),
    eventDescription: icsSelectors.selectIcsEventDescription(appointmentTypeId)(state),
  };
};

AddToCalendarButton.propTypes = {
  eventLocation: PropTypes.string.isRequired,
  eventTitle: PropTypes.string.isRequired,
  eventStartDate: PropTypes.string.isRequired,
  eventEndDate: PropTypes.string.isRequired,
  eventGeolocation: PropTypes.string.isRequired,
  eventDescription: PropTypes.string.isRequired,
};

export const ConnectedAddToCalendarButton = connect(mapStateToProps)(AddToCalendarButton);
